import React, { useCallback, useEffect, useState } from "react";
import { Typography, List, ListItem, ListItemText, Grid2 } from "@mui/material";

import Loading from "../../../../Controller/LoadingController/Loading";
import { GetStreetSeverity } from "../../../../ApiServices/ApiRequests";
import { CountChartData } from "../../../../Models/Models";
import {
  CtmLiveOverViewType,
  useCtmLiveOverView,
} from "../../../../ContextAPI/CtmLiveOverViewContext";
import { useTranslation } from "react-i18next";

const StreetDataTable = () => {
  const [load, setLoad] = useState(false);

  const { ctmLiveOverViewState, dispatchCtmLiveOverView } =
    useCtmLiveOverView();
  const { t } = useTranslation();

  const handleInputChange = useCallback(
    (
      field: keyof CtmLiveOverViewType,
      value: string | boolean | number | null | CountChartData[]
    ) => {
      dispatchCtmLiveOverView({ type: "SET_FIELD", field, value });
    },
    [dispatchCtmLiveOverView]
  );

  const handleBulkChange = useCallback(
    (value: Partial<CtmLiveOverViewType>) => {
      dispatchCtmLiveOverView({ type: "BULK_UPDATE", value });
    },
    [dispatchCtmLiveOverView]
  );

  const retrieveData = async () => {
    try {
      setLoad(true);
      const result: CountChartData[] = await GetStreetSeverity();
      // Assuming the data is in result.data.data
      handleInputChange("StreetDataTableResponse", result);
    } catch (e) {
      console.error("Error fetching  streetTable  count data:", e);
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    retrieveData();
  }, []);

  return (
    <>
      {load ? (
        <Loading loading={load} type={`dots`} backDrop={false} />
      ) : (
        <List
          sx={{
            overflowY: "none",
            margin: 0,
            padding: 0,
            listStyle: "none",
            //maxHeight: 200,
            /* '&::-webkit-scrollbar': {
              width: '0.4em'
            },
            '&::-webkit-scrollbar-track': {
              boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
              webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(0,0,0,.1)',
              outline: '1px solid slategrey'
            } */
          }}
        >
          {ctmLiveOverViewState.StreetDataTableResponse.length > 0 &&
            ctmLiveOverViewState.StreetDataTableResponse?.map((value, i) => {
              {
                if (i < 5) {
                  return (
                    // <ListItem
                    //   key={i}
                    //   style={{ paddingLeft: `10px`, margin: `-12px 0px` }} //paddingLeft: `10px`, marginTop: `-20px`, marginBottom: `-20px`
                    //   disableGutters
                    // >
                    //   <Grid2 container spacing={2} justifyContent="sp">
                    //     <Grid2 size={{ xs: 10, sm: 10, md: 10 }}>
                    //       <ListItemText
                    //         primary={
                    //           <Typography
                    //             variant="body2"
                    //             style={{
                    //               whiteSpace: "pre-wrap",
                    //               overflowWrap: "break-word",
                    //               fontSize: `12px`,
                    //             }}
                    //           >
                    //             {value.name}
                    //           </Typography>
                    //         }
                    //       />
                    //     </Grid2>
                    //     <Grid2
                    //       size={{ xs: 2, sm: 2, md: 2 }}
                    //       style={{ display: "flex", justifyContent: "flex-end" }}
                    //     >
                    //       <ListItemText
                    //         secondary={
                    //           <Typography
                    //             variant="body2"
                    //             style={{
                    //               color: "red",
                    //               fontSize: `12px`,
                    //               textAlign: "right",
                    //             }}
                    //           >
                    //             {value.value}
                    //           </Typography>
                    //         }
                    //       />
                    //     </Grid2>
                    //   </Grid2>
                    // </ListItem>

                    <div
                      key={i}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <Typography
                          variant="body2"
                          style={{
                            whiteSpace: "pre-wrap",
                            overflowWrap: "break-word",
                            fontSize: `12px`,
                            marginLeft: "5px",
                            marginTop: "5px",
                          }}
                        >
                          {value.name}
                        </Typography>
                      </div>

                      <Typography
                        variant="body2"
                        style={{
                          whiteSpace: "pre-wrap",
                          color: "red",
                          overflowWrap: "break-word",
                          fontSize: `12px`,
                          marginRight: "10px",
                          marginTop: "5px",
                        }}
                      >
                        {value.value}
                      </Typography>
                    </div>
                  );
                }
              }
            })}
        </List>
      )}
    </>
  );
};

export default StreetDataTable;
